import React from "react";

const Location = () => {
  return (
    <section id="location" className="h-[70vh] bg-slate-500">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1089.4846133998553!2d20.363979898579807!3d53.11067640334164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471db52459bf146d%3A0x1b4641a9e47b18e!2sLis%20Galeria%20Kostki%20Brukowej%20Materia%C5%82y%20Budowlane!5e0!3m2!1sen!2spl!4v1718839959429!5m2!1sen!2spl"
        title="Location"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      ;
    </section>
  );
};

export default Location;
